import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../../styles/styles';
import { titles } from '../../../../styles/colors';

const { colors, common, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm + spacing.xs,
	},
	fieldLabel: {
		color: titles,
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
		marginBottom: spacing.xs,
	},
	fieldContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
	searchBox: {
		':nth-child(1n)': {
			boxSizing: 'border-box',
			padding: '3px 6px',
			...CssSelectors.allChildren(
				{
					fontSize: 12,
				},
				'input'
			),
		},
	},
	autocompleteBox: {
		width: 233,
		maxHeight: 304,
		overflowY: 'auto',
		overflowX: 'hidden',
		...CssSelectors.allChildren(
			{
				...CssSelectors.allChildren(
					{
						...CssSelectors.allChildren(
							{
								padding: '5px 10px',
							},
							'div'
						),
					},
					'div'
				),
				width: 205,
			},
			'div'
		),
	},
	searchIcon: {
		marginRight: 8,
		marginTop: 5,
	},
	sectionWrap: {
		borderBox: 'box-sizing',
		alignItems: 'center',
		display: 'flex',
		padding: 10,
		borderTop: common.border,
		borderBottom: common.border,
	},
	sectionTitle: {
		minWidth: 200,
		color: colors.primary.main,
		fontSize: 14,
		margin: 0,
	},
	selectedTagContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: spacing.xs,
		marginTop: spacing.xs,
	},
	selectedTag: {
		':nth-child(1n)': {
			padding: '4px 8px',
		},
	},
});
